import script from "./SidebarSpeed.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarSpeed.vue?vue&type=script&setup=true&lang=js"

import "./SidebarSpeed.vue?vue&type=style&index=0&id=68b59034&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68b59034"]])

export default __exports__